export function countContentByType(playlist, contentType) {
    if (!playlist.sections) return 0
    return playlist.sections.reduce((count, section) => {
        return count + section.content.filter(match('type', contentType)).length
    }, 0)
}

export function filterArray(arr, search) {
    let lowSearch = search.toLowerCase()
    return arr.filter((user) => {
        return Object.values(user).some((val) => String(val).toLowerCase().includes(lowSearch))
    })
}

export function findContentIndexesByPk(playlist, pk) {
    let result = { contentIndex: null, sectionIndex: null }

    playlist.sections.forEach((section, sectionIndex) => {
        section.content.forEach((content, contentIndex) => {
            if (pk === content.pk) {        
                result = {
                    contentIndex,
                    contentName: content.meta.title[0].text,
                    sectionIndex,
                    sectionName: section.title[0].text
                }
            }
        })
    })

    return result
}

export function findDuplicateContentByType(playlist, contentType) {
    const set = new Set([])
    let duplicates = {}

    playlist.sections.forEach((section, sectionIndex) => {
        section.content.forEach((content, contentIndex) => {
            if (content.type === contentType) {
                if (set.has(content.pk)) {
                    // Check if first or n-th duplicate
                    if (!duplicates[content.pk]) {
                        duplicates[content.pk] = {
                            occurrences: getAllOccurrencesById(playlist, content.pk)
                        }
                    }
                } else {
                    set.add(content.id)
                }
            }
        })
    })

    return duplicates
}

export function findValue(arr, string) {
    return arr.filter((x) => x.name.toLowerCase().includes(string.toLowerCase()))
}

function getAllOccurrencesById(playlist, contentPk) {
    let occurrences = []

    playlist.sections.forEach((section, sectionIndex) => {
        section.content.forEach((content, contentIndex) => {
            if (content.pk === contentPk) {
                occurrences.push({
                    content,
                    sectionIndex,
                    contentIndex
                })
            }
        })
    })

    return occurrences
}

export const groupBy = (items, key) =>
    items.reduce(
        (result, item) => ({
            ...result,
            [item[key]]: [...(result[item[key]] || []), item],
        }),
        {}
    )

export function groupByArray(xs, key) {
    return xs.reduce(function (rv, x) {
        let v = key instanceof Function ? key(x) : x[key]
        let el = rv.find((r) => r && r.key === v)
        if (el) {
            el.values.push(x)
        } else {
            rv.push({ key: v, values: [x] })
        }
        return rv
    }, [])
}

export function immutableReplace(arr, index, newItem) {
    return arr
        .slice(0, index)
        .concat(newItem)
        .concat(arr.slice(index + 1))
}

export function includesAny(arr, any) {
    return any.map((item) => arr.includes(item)).includes(true)
}

export function isContentComplete(content, playlist, trainingResult) {
    if (!trainingResult) return false
    if (content.type === 'VIDEO' && trainingResult.videosCompleted) {
        return trainingResult.videosCompleted.some(pk => pk === content.pk)
    } else if (content.type === 'QUIZ' && trainingResult.quizzesCompleted) {
        return trainingResult.quizzesCompleted.some(pk => pk === content.pk)
    } else if (content.type === 'CONNECTION' && !content.hidden) {
        const contentIndexes = findContentIndexesByPk(playlist, content.to)
        return isSectionComplete(playlist.sections[contentIndexes.sectionIndex], playlist, trainingResult)
    } else {
        return true
    }
}

export function isSectionComplete(section, playlist, trainingResult) {
    return section.content.every(content => isContentComplete(content, playlist, trainingResult))
}

export function match(key, val) {
    return (obj) => obj[key] === val
}

export const removeDuplicates = (data) =>
    data.reduce((a, b) => {
        if (a.indexOf(b) < 0) a.push(b)
        return a
    }, [])

export function deepFilter(arr, searchString) {
    return arr.filter(item => {
        if (typeof item === 'object' && item !== null) {
            // Recursively filter object properties
            const filteredProps = deepFilter(Object.values(item), searchString);
            return filteredProps.length > 0;
        } else if (typeof item === 'string' && item.includes(searchString)) {
            // Filter strings that include the search string
            return true;
        }
        return false;
    });
}